import script from "./ImageGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageGrid.vue?vue&type=script&setup=true&lang=js"

import "./ImageGrid.vue?vue&type=style&index=0&id=0c0aed22&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c0aed22"]])

export default __exports__